import React from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Building,
  CreditCard,
  History,
  FileText,
  Settings,
  ArrowLeft,
  ArrowRight
} from 'lucide-react';

/**
 * PAGE: PAIEMENTS ENTREPRISES (ADMIN) - NIVEAU 2
 * 
 * Modules de paiement pour les entreprises
 */

const AdminPaymentsEntreprises = () => {
  const navigate = useNavigate();

  const modules = [
    {
      title: 'Paiements',
      subtitle: 'Paiements de masse',
      description: 'Traiter les paiements groupés des entreprises',
      icon: CreditCard,
      path: '/payments/bulk',
      color: 'purple'
    },
    {
      title: 'Historique',
      subtitle: 'Historique des paiements',
      description: 'Consulter et gérer tous les paiements de masse',
      icon: History,
      path: '/payments/history-entreprise',
      color: 'green'
    },
    {
      title: 'Appel à cotisation',
      subtitle: 'Appels à cotisation',
      description: 'Générer et envoyer les appels à cotisation',
      icon: FileText,
      path: '/contribution-calls',
      color: 'orange'
    },
    {
      title: 'Configuration',
      subtitle: 'Configuration entreprises',
      description: 'Paramétrer les canaux de communication (Email & FTP)',
      icon: Settings,
      path: '/enterprise-payment-config',
      color: 'gray'
    }
  ];

  const getColorClasses = (color) => {
    const colors = {
      purple: 'bg-purple-100 text-purple-600 group-hover:bg-purple-200 hover:border-purple-300',
      green: 'bg-green-100 text-green-600 group-hover:bg-green-200 hover:border-green-300',
      orange: 'bg-orange-100 text-orange-600 group-hover:bg-orange-200 hover:border-orange-300',
      gray: 'bg-gray-100 text-gray-600 group-hover:bg-gray-200 hover:border-gray-300'
    };
    return colors[color] || colors.purple;
  };

  const getTextColor = (color) => {
    const colors = {
      purple: 'text-purple-600',
      green: 'text-green-600',
      orange: 'text-orange-600',
      gray: 'text-gray-600'
    };
    return colors[color] || colors.purple;
  };

  return (
    <div className="space-y-6">
      {/* En-tête avec bouton retour */}
      <div className="bg-white rounded-xl shadow-card p-6">
        <button
          onClick={() => navigate('/admin/payments')}
          className="flex items-center text-gray-600 hover:text-primary-600 mb-4 transition-colors duration-200"
        >
          <ArrowLeft className="h-5 w-5 mr-2" />
          <span className="text-sm font-medium">Retour aux paiements</span>
        </button>

        <div className="flex items-center">
          <div className="p-3 rounded-lg bg-purple-100 text-purple-600 mr-4">
            <Building className="h-8 w-8" />
          </div>
          <div>
            <h1 className="text-2xl font-bold text-primary-900 mb-1">
              Paiements Entreprises
            </h1>
            <p className="text-gray-600">
              Gestion des paiements groupés
            </p>
          </div>
        </div>
      </div>

      {/* Cartes des modules */}
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        {modules.map((module, index) => (
          <button
            key={index}
            onClick={() => navigate(module.path)}
            className={`bg-white rounded-xl shadow-card p-8 text-left hover:shadow-xl transition-all duration-200 transform hover:-translate-y-1 group border-2 border-transparent ${getColorClasses(module.color)}`}
          >
            <div className="flex flex-col items-center text-center">
              <div className={`p-6 rounded-2xl mb-6 transition-colors duration-200 ${getColorClasses(module.color)}`}>
                <module.icon className="h-16 w-16" />
              </div>
              
              <h2 className="text-2xl font-bold text-gray-900 mb-2">
                {module.title}
              </h2>
              
              <p className="text-sm font-medium text-gray-700 mb-3">
                {module.subtitle}
              </p>
              
              <p className="text-gray-600 mb-6">
                {module.description}
              </p>

              <div className={`flex items-center text-sm font-semibold ${getTextColor(module.color)}`}>
                <span>Accéder</span>
                <ArrowRight className="h-5 w-5 ml-2 group-hover:translate-x-1 transition-transform duration-200" />
              </div>
            </div>
          </button>
        ))}
      </div>
    </div>
  );
};

export default AdminPaymentsEntreprises;
